<template>
  <div class="plan_wrap">
    <div class="plan_box" @click="handleClick(info)">
      <!-- 月 -->
      <template v-if="isMonthBuy">
        <h5 class="hyphenate-text">{{ $t('FoodC_membership_fBAi_MQrN' /** 按月购买*/) }}</h5>
        <div v-if="hasMarketingPrice" class="favorable price">
          {{
            $t('FoodC_membership_hDlN_ORJH', {
              money1: info.priceSplit.display,
              money2: info.renewPriceSplit.display,
            })
          }}
        </div>
        <div v-else class="price">
          {{ $t('FoodC_update_QaEe_FhNn', { money: info.priceSplit.display } /*bb/月*/) }}
        </div>
      </template>
      <!-- 其他 周期 -->
      <template v-else>
        <h5 class="hyphenate-text">
          {{ cyclePlanText }}<span class="tag">{{ $t('FoodC_membership_sKhv_iXXm') }}</span>
        </h5>
        <div class="price">
          {{ $t('FoodC_membership_mteQ_ejcJ', { money: info.monthPriceSplit.display } /*bb/月*/) }}
        </div>
        <div class="favorable">
          <p>
            {{ longTermPriceText }}
          </p>
          <p v-html="$t('FoodC_membership_ootV_ZRYt', { percent: savePercentText })"></p>
        </div>
      </template>
      <!-- 按钮 -->
      <div class="solt_pos_box" :class="isSelected && 'solt_pos_box_active'">
        <div class="icon_info" :class="isSelected && 'pos_active'"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { CYCLE_TYPE } from '@/page/member/common/enumsUtil.js'

export default {
  name: 'PlanItemComp',
  props: {
    isSelected: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    isMonthBuy() {
      return this.info?.cycleType === CYCLE_TYPE.month
    },
    hasMarketingPrice() {
      /**
       * 无营销价格  售价=订阅价
       * 有营销价格  售价 < 订阅价
       * 订阅价：renewPrice
       * 售价：price
       */
      const renewPrice = this.info?.renewPrice || 0
      const price = this.info?.price || 0
      return price < renewPrice
    },
    cyclePlanText() {
      let text = ''
      switch (this.info?.cycleType) {
        case CYCLE_TYPE.quarter:
          text = this.$t('FoodC_membership_dmqk_wJgV')
          break
        case CYCLE_TYPE.halfYear:
          text = this.$t('FoodC_membership_XTeP_nLeJ')
          break
        case CYCLE_TYPE.year:
          text = this.$t('FoodC_membership_BIGZ_CvrZ')
          break
      }
      return text
    },
    longTermPriceText() {
      let money = ''
      const dynamicContent = { money: this.info.priceSplit.display }
      switch (this.info?.cycleType) {
        case CYCLE_TYPE.quarter:
          money = this.$t('FoodC_membership_uAos_hrFr', dynamicContent)
          break
        case CYCLE_TYPE.halfYear:
          money = this.$t('FoodC_membership_CHIm_nRPw', dynamicContent)
          break
        case CYCLE_TYPE.year:
          money = this.$t('FoodC_membership_nksN_IHwY', dynamicContent)
          break
      }
      return money
    },
    savePercentText() {
      return `<span>${this.info.savePercent}%</span>`
    },
  },
  methods: {
    handleClick(item) {
      this.$emit('onSelect', item)
    },
  },
}
</script>

<style lang="scss" scoped>
.plan_wrap {
  clear: both;
  margin-bottom: 20px;
}
.plan_box {
  position: relative;
  width: 100%;
  padding: 40px;
  box-sizing: border-box;
  background: #f5f5f7;
  border-radius: 40px;
  h5 {
    max-width: 530px;
    font-family: DiDiSans-Pro-ExtraBoldTest;
    font-size: 32px;
    color: #0b0b0d;
    line-height: 40px;
    .tag {
      margin-left: 16px;
      padding: 4px 12px;
      border-radius: 6px 15px 6px 15px;
      background: #f46021;
      font-family: DiDiSans-Pro-Bold;
      font-size: 20px;
      color: #fff;
      letter-spacing: 0;
      position: relative;
      top: -4px;
    }
  }
  .price {
    max-width: 530px;
    font-family: DiDiSans-Pro-Medium;
    font-size: 32px;
    color: #0b0b0d;
    line-height: 40px;
    margin-top: 8px !important;
    span {
      margin-left: 12px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      color: #89898c;
      line-height: 36px;
      text-decoration: line-through;
    }
  }
  .favorable {
    max-width: 530px;
    margin-top: 20px;
    p {
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      color: #89898c;
      line-height: 36px;
      margin-bottom: 4px;
      ::v-deep span {
        font-family: DiDiSans-Pro-Bold;
        font-size: 28px;
        color: #ff5f14;
        line-height: 36px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .solt_pos_box {
    position: absolute;
    top: 40px;
    right: 40px;
    .icon_info {
      background: #fff;
      font-size: 0;
      width: 35px;
      height: 35px;
      border: 5px solid #cacacc;
      border-radius: 50%;
      &.pos_active {
        width: 15px;
        height: 15px;
        border: 15px solid #16161a;
        box-sizing: content-box;
      }
    }
  }
  .solt_pos_box_active {
    top: 50%;
    right: 40px;
    margin-top: -20px;
  }
}
</style>
